export default {
  api: 'https://beeftrader-services.appbeeftrader-br.com/app'
}
